import React, {Component} from 'react';
import {connect} from 'react-redux';
import ThemenFulltextSearch from '../containers/ThemenFulltextSearch'
import ReferentenFulltextSearch from '../containers/ReferentenFulltextSearch'
import ReferentenEinsatzgebietSelect from '../containers/ReferentenEinsatzgebietSelect'
import ReferentenBezirkeSelect from "../containers/ReferentenBezirkeSelect";
import ReferentenKreiseSelect from "../containers/ReferentenKreiseSelect"
import {BarLoader} from 'react-spinners';
import {fetchThemen} from "../actions/referenten/themen";
import {fetchBezirke} from "../actions/referenten/bezirke";
import {fetchKreise} from "../actions/referenten/kreise";

class ThemenFilters extends Component {

    componentDidMount() {
        this.props.dispatch(fetchThemen());
        this.props.dispatch(fetchBezirke());
        this.props.dispatch(fetchKreise());
    }

    render() {
        if (window.bbvTermine && window.bbvTermine.filter === false) {
            return null
        }

        if (!this.props.ready) {
            return <div className={'termin-filter'}>
                <BarLoader/>
            </div>
        }
        return <div className={'termin-filter'}>
            <div className={'well'}>
                <div className={'well-title'}><h3>Suche</h3></div>
                <div className={'row'}>
                    <div className={'col-sm-6'}>
                        <ThemenFulltextSearch/>
                    </div>
                    <div className={'col-sm-6'}>
                        <ReferentenFulltextSearch/>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col-sm-12'}>
                        <ReferentenEinsatzgebietSelect/>
                    </div>
                </div>
            </div>
            <div className={'well'}>
                <div className={'well-title'}><h3>Wohnort des Referenten</h3></div>
                <div className={'row'}>
                    <div className={'col-sm-4'}>
                        <ReferentenBezirkeSelect/>
                    </div>
                    <div className={'col-sm-8'}>
                        <ReferentenKreiseSelect/>
                    </div>
                </div>
            </div>
        </div>
    }
}


const mapStateToProps = store => {
    if (store.bezirke.list.length > 0) {
        return {
            ready: true
        }
    }

    return {
        themenCount: store.themen.list.total,
        ready: false
    }

}

export default connect(mapStateToProps)(ThemenFilters)



// WEBPACK FOOTER //
// ./src/containers/ThemenFilters.js